import { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import useUser from '../api/hooks/useUser';
import { authenticationPagesList } from '../consts/authenticationPagesList';
import { contentPagesList } from '../consts/contentPagesList';
import MainContext from '../context/MainContext';
import { renderPages } from '../utils/renderPages';
import { useState } from 'react';
import { deleteCookie, getCookie } from '../utils/handleCookie';
import { cookieName } from '../consts/cookie';
import { possible_statuses } from '../consts/possible_statuses';
import useLogout from '../api/hooks/authentication/useLogout';
import ModelEditPage from '../sections/agency/modelSubsections/ModelEditPage';
import LoginPage from '../sections/authentication/LoginPage';
import FirstAccessPage from '../sections/authentication/FirstAccessPage';
import RecoveryPasswordPage from '../sections/authentication/RecoveryPasswordPage';
import ResetPasswordPage from '../sections/authentication/ResetPasswordPage';
import OverviewPage from '../sections/agency/OverviewPage';
import ModelsPage from '../sections/agency/ModelsPage';
import ModelDetailsPage from '../sections/agency/modelSubsections/ModelDetailsPage';
import OffersPage from '../sections/agency/OffersPage';
import OfferDetailsPage from '../sections/agency/offersSubsections/OfferDetailsPage';
import ShareOfferPage from '../sections/agency/offersSubsections/ShareOfferPage';
import ClientsPage from '../sections/general/ClientsPage';
import ClientDetailsPage from '../sections/general/clientSubsections/ClientDetailsPage';
import SettingsPage from '../sections/general/SettingsPage';
import UserDetailsPage from '../sections/general/settingSubsections/UserDetailsPage';
import { Verify } from 'crypto';
import VerifyPage from '../sections/authentication/VerifyPage';
import FilterContext from '../context/FilterContext';

const Page = (props: any) => {
    const { user, setUser, token, setToken } = useContext(MainContext);
    const { RESPONSES, RESULTS, CTAs } = useUser();

    /* do not mute these */
    const contentPages = renderPages(contentPagesList, props);
    const authenticationPages = renderPages(authenticationPagesList, props);
    /* do not mute these */

    /*  deleteCookie(cookieName.token);     */

    // useEffect(() => {
    //     if (token) {
    //         CTAs.getUserByToken(token);
    //     }
    // }, []);

    // useEffect(() => {
    //     if (token) {
    //     } else if (
    //         window.location.pathname === `/login` ||
    //         window.location.pathname === `/resetpassword` ||
    //         window.location.pathname === `/recoverypassword` ||
    //         window.location.pathname === `/verify` ||
    //         window.location.pathname.includes(`/offerts/share/`)
    //     ) {
    //     } else {
    //         window.location.href = window.location.origin + '/login';
    //     }
    // });

    // useEffect(() => {
    //     /* console.log(RESPONSES.getUserResponse, RESULTS.getUserResult); */
    //     if (RESULTS.getUserResult?.status === possible_statuses.token.expired) {
    //         deleteCookie(cookieName.token);
    //     } else if (RESPONSES.getUserResponse?.ok) {
    //         setUser(RESULTS.getUserResult.user);
    //     } else if (RESPONSES.getUserResponse?.ok == false) {
    //         window.location.href = window.location.origin + '/login';
    //     }
    // }, [RESPONSES.getUserResponse]);

    useEffect(() => {
        const pathName = window.location.pathname;
        if (pathName === '/') {
            window.location.href = window.location.origin + '/login';
        }
    }, []);

    useEffect(() => {
        const getLocalUser = localStorage.getItem('userData');
        const getLocalToken = localStorage.getItem('userToken');
        if (getLocalUser) {
            setUser(JSON.parse(getLocalUser));
        }
        if (getLocalToken) {
            setToken(getLocalToken);
        }
    }, []);

    const [fCtxIsCategoriesOpen, setFCtxIsCategoriesOpen] = useState(false);
    const [fCtxIsFeaturesOpen, setFCtxIsFeaturesOpen] = useState(false);
    const [fCtxIsPlaceOpen, setFCtxIsPlaceOpen] = useState(false);
    const [fCtxName, setFCtxName] = useState('');
    const [fCTxParams, setFCtxParams] = useState({});
    const [fCTxTraits, setFCtxTraits] = useState({});
    const [fCTxCategories, setFCtxCategories] = useState({});
    const [fCtxPlace, setFCtxPlace] = useState({});

    return (
        <div /* className="page-wrapper" */>
            <Router>
                <Routes>
                    {/* {authenticationPages} */}
                    <Route path={`/login`} element={<LoginPage props={props} />} />
                    {/* <Route path={`/register`} element={<LoginPage props={props} />} /> */}
                    <Route path={`/firstaccess`} element={<FirstAccessPage props={props} />} />
                    <Route path={`/recoverypassword`} element={<RecoveryPasswordPage props={props} />} />
                    <Route path={`/resetpassword`} element={<ResetPasswordPage props={props} />} />
                    <Route path={`/verify`} element={<VerifyPage props={props} />} />
                    {/* {token && contentPages} */}
                    {/* {token && <Route path={`/overview`} element={<OverviewPage props={props} />} />} */}
                    {/* {token && (
                        <Route
                            path={`/models`}
                            element={
                                <FilterContext.Provider
                                    value={{
                                        isCategoriesOpen: fCtxIsCategoriesOpen,
                                        isFeaturesOpen: fCtxIsFeaturesOpen,
                                        isPlaceOpen: fCtxIsPlaceOpen,
                                        setIsCategoriesOpen: setFCtxIsCategoriesOpen,
                                        setIsFeaturesOpen: setFCtxIsFeaturesOpen,
                                        setIsPlaceOpen: setFCtxIsPlaceOpen,
                                        name: fCtxName,
                                        setName: setFCtxName,
                                        params: fCTxParams,
                                        setParams: setFCtxParams,
                                        traits: fCTxTraits,
                                        setTraits: setFCtxTraits,
                                        categories: fCTxCategories,
                                        setCategories: setFCtxCategories,
                                        place: fCtxPlace,
                                        setPlace: setFCtxPlace,
                                    }}
                                >
                                    <ModelsPage props={props} />
                                </FilterContext.Provider>
                            }
                        />
                    )} */}
                    {/* {token && <Route path={`/models/:id`} element={<ModelDetailsPage props={props} />} />}
                    {token && <Route path={`/models/:id/edit`} element={<ModelEditPage props={props} />} />}
                    {token && <Route path={`/models/create`} element={<ModelEditPage props={props} />} />} */}
                    {token && <Route path={`/offers`} element={<OffersPage props={props} />} />}
                    {token && <Route path={`/offers/:sku`} element={<OfferDetailsPage props={props} />} />}
                    {
                        <Route
                            path={`/offerts/share/:id`} // modified "offer"t"s" to match the link provided by share API
                            element={<ShareOfferPage props={props} />}
                        />
                    }
                    {/* {token && <Route path={`/clients`} element={<ClientsPage props={props} />} />}
                    {token && <Route path={`/clients/:id`} element={<ClientDetailsPage props={props} />} />} */}
                    {token && <Route path={`/settings`} element={<SettingsPage props={props} />} />}
                    {token && <Route path={`/settings/user/:id`} element={<UserDetailsPage props={props} />} />}
                </Routes>
            </Router>
        </div>
    );
};
export default Page;
